export const PAGE_SIZE_OPTIONS = [20, 40, 80, 160] as const

// One key for the ALP and every storefront, like the List View action panel's
// stored preference.
const STORAGE_KEY = 'ListingSearch:pageSize'

const isPageSizeOption = (value: number) =>
  (PAGE_SIZE_OPTIONS as readonly number[]).includes(value)

/**
 * The buyer's last explicit page-size selection, or null when nothing usable
 * is stored. Client-only: localStorage is unreadable during SSR, so call this
 * from an effect or an event handler, never during render.
 */
export const readRememberedPageSize = (): number | null => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (raw === null || !/^\d+$/.test(raw)) return null
    const value = Number(raw)
    return isPageSizeOption(value) ? value : null
  } catch {
    return null
  }
}

/** Call only on a deliberate selection from the page-size dropdown. */
export const writeRememberedPageSize = (pageSize: number) => {
  if (!isPageSizeOption(pageSize)) return
  try {
    window.localStorage.setItem(STORAGE_KEY, String(pageSize))
  } catch {
    // Storage can be unavailable (e.g. blocked or full); the selection still
    // applies for this page, it just isn't remembered. Drop any older value so
    // it can't be restored over the buyer's newer choice.
    try {
      window.localStorage.removeItem(STORAGE_KEY)
    } catch {
      // Unreadable storage restores nothing anyway.
    }
  }
}
